/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".border[_ngcontent-%COMP%] {\n  padding: 20px; }\n\n.border-inner[_ngcontent-%COMP%] {\n  border: 1px solid lightgrey;\n  padding: 5px;\n  margin: 5px; }\n\n.settingsRadioButtonLabel[_ngcontent-%COMP%] {\n  font-size: 1.2em;\n  padding-left: 10px; }\n\ninput[type=radio][_ngcontent-%COMP%] {\n  width: 1.1em;\n  height: 1.1em; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/settings/settings.component.scss.shim.ngstyle.js.pre-build-optimizer.js